module.exports = __webpack_public_path__ + "img/Organization.29cdacfe.png";